module.exports = __webpack_public_path__ + "img/kehu_02.d6384394.png";